<template>
    <b-row>
        <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

            <b-form @submit.prevent="save">
                <b-card>
                    <b-form-row>
                        <lg-form-input invalidFeedback="Informe um número válido!" description=" "
                            :error="$v.form.numero" v-model="form.numero" label="Nº Produto:" cols="12" md="12" sm="12"
                            disabled />

                        <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                            :error="$v.form.descricaoResumida" v-model="form.descricaoResumida" label="Descrição:*"
                            cols="12" md="12" sm="12" />

                        <b-col cols="12">
                            <lg-finder-page-classe :prefix="prefix + title + ' > '" id="finderClasseProdutoForm"
                                @onselect="selectClasse" v-model="form.classe" label="Classe:*"></lg-finder-page-classe>
                        </b-col>

                        <b-col cols="12">
                            <lg-finder-page-tipo-medida :prefix="prefix + title + ' > '"
                                id="finderTipoMedidaProdutoForm" @input="selectTipoMedida" v-model="form.tipoMedida"
                                label="Tipo Medida:*"></lg-finder-page-tipo-medida>
                        </b-col>


                        <lg-form-input invalidFeedback="Informe um Fator de Conversão!" description=" "
                            :disabled="(!form.classe || !form.classe.id) || (!form.tipoMedida || !form.tipoMedida.id)"
                            :error="$v.form.estoqueSeguranca" v-model="form.fatorConversao" label="Fator de Conversão:"
                            cols="12" md="12" sm="12" />


                        <b-col cols="12">

                            <lg-finder-page-tipo-medida
                                :podeApagar="!((!form.classe || !form.classe.id) || (!form.tipoMedida || !form.tipoMedida.id))"
                                :podeMudar="!((!form.classe || !form.classe.id) || (!form.tipoMedida || !form.tipoMedida.id))"
                                id="finderUnidadeConversaoProdutoForm" @input="selectUnidadeConversao"
                                label="Unidade de Conversão:"
                                v-model="form.unidadeConversao"></lg-finder-page-tipo-medida>
                        </b-col>

                        <lg-form-select v-model="form.prioridade" :loadFunction="listStatus"
                            labelFormGroupBind="Prioridade Produto:*" label="nome" description="" sm="12" />



                        <lg-form-input :disabled="form.utilizaEstoqueMinimo == 1"
                            invalidFeedback="Informe um percentual válido!" description=" "
                            :error="$v.form.estoqueSeguranca" v-model="form.estoqueSeguranca"
                            label="Fator de segurança (%):" cols="12" md="12" sm="12" />

                        <lg-form-input invalidFeedback="Informe um estoque mínimo!" description=" "
                            :disabled="form.utilizaEstoqueMinimo == 0" :error="$v.form.estoqueMinimo"
                            v-model="form.estoqueMinimo" label="Estoque mínimo (UN):" cols="5" md="5" sm="5" />

                        <b-form-group class="col-6 text-right mt-3">
                            <b-form-checkbox v-model="form.utilizaEstoqueMinimo" :value="1" :unchecked-value="0">
                                Utilizar estoque mínimo
                            </b-form-checkbox>
                        </b-form-group>
                    </b-form-row>

                    <b-form-row>
                        <b-form-group label="Status:*" class="ml-3">
                            <b-form-radio-group v-model="form.situacao" :options="statusOptions" size="sm"
                                name="status-inline"></b-form-radio-group>
                        </b-form-group>
                    </b-form-row>


                    <b-form-row>
                        <b-form-group label="Produto Monitorado:" class="ml-3">
                            <b-form-radio-group v-model="form.monitorado" :options="monitoradoOptions" size="sm"
                                name="monitoramento-inline"></b-form-radio-group>
                        </b-form-group>
                    </b-form-row>

                    <b-form-row>

                        <b-form-group label="Tipo de Texto:" class="ml-3">
                            <b-form-radio-group v-model="form.tipoTexto" :options="tipoTextoOptions" size="sm"
                                name="tipo-texto-inline"></b-form-radio-group>
                        </b-form-group>
                    </b-form-row>

                    <b-form-row>

                        <lg-form-input invalidFeedback=" " description=" " v-model="form.periodoMonitoramento"
                            label="Período de Monitoramento:" cols="6" md="6" sm="6" />

                        <span class="mt-3"
                            style="margin-left: -5px;  background-color: #E6E6E6; border-color: #B5B5B5; height: 25px; padding: 3px;">dias
                            anteriores</span>

                    </b-form-row>

                    <b-form-row>
                        <b-col cols="12"> <b-form-group label="Texto Específico:" label-for="textarea-large">
                                <b-form-textarea id="textarea-large" size="lg"
                                    v-model="form.textoEspecifico"></b-form-textarea>
                            </b-form-group>
                        </b-col>

                    </b-form-row>

                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvarProdutoForm" class=" my-2" size="sm" pill variant="success"
                                @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvarProdutoForm" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelarProdutoForm" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelarProdutoForm" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>



                </b-card>
            </b-form>
        </b-modal>
    </b-row>

</template>
<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFinderPageClasse from '@/components/Finders/LgFinderPageClasse.vue'
import LgFinderPageTipoMedida from "@/components/Finders/LgFinderPageTipoMedida.vue";

export default {
    components: {
        LgFinderPageClasse,
        LgFinderPageTipoMedida,
        LgFormInput,
        LgFormSelect
    },
    mixins: [FormResourceMixin],
    props: {
        id: Number,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Cadastro",
        },

    },
    validations: {
        form: {

            descricaoResumida: { required },
            situacao: { required },
            tipoMedida: { required },
            prioridade: { required },
            classe: { required },
        },
    },
    data() {
        return {
            showModal: true,
            tipoTextoOptions: [
                { text: "Padrão", value: 0 },
                { text: "Específico", value: 1 },
            ],

            monitoradoOptions: [
                { text: "Sim", value: 1 },
                { text: "Não", value: 0 },
            ],
            statusOptions: [
                { text: "Ativo", value: 1 },
                { text: "Inativo", value: 0 },
            ],

            form: {
                utilizaEstoqueMinimo: 0,
                estoqueSeguranca: "",
                descricaoResumida: "",
                numero: "",
                fatorConversao: "",
                unidadeConversao: {},
                tipoMedida: {},
                prioridade: {},
                classe: {},
                situacao: 1,
                textoEspecifico: "",
            },
        };
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/produto`);
        this.$prioridadeService = new ResourceService(`/api/prioridades`);


        if (this.id) {
            const { data } = await this.$service.findById(this.id);
            this.form = data;

        } else {
            this.form.situacao = 1;
        }

    },


    methods: {
        async listStatus({ filter, page = 1 }) {
            return this.$prioridadeService.findAll({ filter, page, limit: 5 })
        },

        selectUnidadeConversao(item) {
            this.form.unidadeConversao = item;
        },
        selectTipoMedida(item) {
            this.form.tipoMedida = item;
        },
        selectClasse(item) {
            this.form.classe = item;
        },
        cancelar() {
            this.$emit("close");
        },

        async save() {
            if (!this.formIsValid || (this.form.utilizaEstoqueMinimo && (!this.form.estoqueMinimo || this.form.estoqueMinimo <= 0))) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                });
                return;
            }

            await this.$saveResource(this.form, "");
            this.cancelar();
        },
    },
};
</script>
